// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search .search-tab[data-v-3e289484]{margin:19px 0 20px}.search-result-count[data-v-3e289484]{font-size:14px;color:#888;font-weight:400}.search .search-topcate[data-v-3e289484]{margin-top:14px}.search .search-unit-box[data-v-3e289484]{width:720px}.search .search-unit-item[data-v-3e289484]{width:100%;padding:20px 0;box-sizing:border-box;border-bottom:1px solid #e8e8e8}", ""]);
// Exports
module.exports = exports;
